import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=63259a6e&"
import script from "./warehouse.vue?vue&type=script&lang=ts&"
export * from "./warehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports